import Http from '../../common/services/Http';
import { SystemSettingDto, UpsertSystemSettingItem } from './models/SystemSettingDto';

class SystemSettingsService {

    public get(prefix?: string) {
        const query = prefix ? `?prefix=${encodeURIComponent(prefix)}` : '';
        return Http.get<SystemSettingDto[]>(`systemsettings${query}`);
    }

    public update(items: UpsertSystemSettingItem[]) {
        return Http.put('systemsettings', { items });
    }

}

export default new SystemSettingsService();
